<template>
  <div class="zip-upload-wrap">
    <el-upload
      class="upload-demo"
      drag
      action="#"
      :before-upload="handleBeforeUpload"
      :show-file-list="false"
    >
      <div class="zip-upload-main">点击上传 / 拖拽到此区域</div>
      <div class="zip-upload-tip">请上传zip文件，大小在10MB以内</div>
    </el-upload>
    <div v-if="uploadedDocName" class="zip-upload-file-name">
      <i class="el-icon-document"></i>
      <span>{{ uploadedDocName }}</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      uploadedDocName: "",
    };
  },
  created() {
    this.uploadedDocName = localStorage.getItem("docName") || "";
  },
  methods: {
    async handleBeforeUpload(file) {
      const isZip =
        file.type === "application/x-zip-compressed" || /\.zip$/i.test(file.name);
      const isLt10M = file.size / 1024 / 1024 <= 10;
      if (!isZip) {
        this.$tool.PromptBox("error", "请上传zip文件");
        return false;
      }
      if (!isLt10M) {
        this.$tool.PromptBox("error", "文件大小不能超过 10MB！");
        return false;
      }
      const arr = await this.$tool.onFileChangeNew(
        this.$tool.makeFileEvent(file),
        { maxSizeMB: 10 }
      );
      if (arr && arr.code == 0) {
        this.uploadedDocName = arr.docName || file.name || "";
      }
      return false;
    },
  },
};
</script>

<style lang="less" scoped>
.zip-upload-wrap {
  margin-top: 0;
}

/deep/ .el-upload {
  width: 250px;
}

/deep/ .el-upload .el-upload-dragger {
  width: 250px;
  height: 100px;
  border: 1px dashed #409eff;
  background: #fff;

  &:hover {
    border-color: #409eff;
  }
}

.zip-upload-main {
  font-size: 12px;
  color: #409eff;
  margin-top: 28px;
  line-height: 18px;
}

.zip-upload-tip {
  font-size: 10px;
  color: #999;
  margin-top: 6px;
  line-height: 14px;
}

.zip-upload-file-name {
  margin-top: 8px;
  font-size: 12px;
  color: #409eff;
  display: flex;
  align-items: center;

  i {
    margin-right: 4px;
  }
}
</style>
